<script>
export default {
  name: 'cardCommercial',
  components: {

  },
  data: () => ({

  }),
  computed: {

  },

  methods: {
  },
  mounted () {
  }
}
</script>

<template>
<md-card md-with-hover>
  <md-ripple>
    <md-card-header>
      <md-avatar>
        <img src="../assets/img/Klaas_profilePicture.jpg" alt="Klaas"/>
      </md-avatar>

      <div class="md-title">Klaas Nienhuis</div>
      <div class="md-subhead">3D developer</div>
    </md-card-header>
    <md-divider></md-divider>
    <md-card-content>Hi, I'm Klaas and I've built this demo. Get in touch to work with a team of specialists. We're experienced in building 3d configurators from A to Z.
    </md-card-content>

    <md-card-actions>
      <md-button class="md-raised md-accent" href="https://klaasnienhuis.freshsales.io/web_forms/404bcc64bc2b7d2fadc81f06d07264e35c21a9cc6c36e680a1bd52d8b929b501/form.html" target="_blank">Contact</md-button>
      <!-- <md-button class="md-raised md-accent" href="https://www.klaasnienhuis.nl" target="_blank">Visit online</md-button> -->
    </md-card-actions>
  </md-ripple>
</md-card>
</template>

<style lang="scss" scoped>
.loader {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
